/*
 *   File : success.js
 *   Author : https://evoqins.com
 *   Description : success modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//Custom components
import { Icon } from '../Icon';
import { SecondaryButton } from '../Buttons';

const SuccessModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("success-modal-close");
        button.click();
    };

    // handle success 
    const _handleSuccess = () => {
        props.handleSuccess();
        _handleCloseModal();
    };

    return (
        <div className="modal fade"
            id="success-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="sendReportModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='success-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.title}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleSuccess} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 pb-1 padding-32px-lr'>
                        <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                            {props.description}
                        </p>
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                        <SecondaryButton name="OK"
                            className="py-3 padding-66px-lr"
                            onClick={_handleSuccess} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessModal;
